module.exports = __webpack_public_path__ + "static/media/om.5f391986.webp";